import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import handleOpenWhatsApp from 'services/whatsappService';

const AreYouReady = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 700 }}
        variant={'h2'}
        gutterBottom
        align={'center'}
        marginBottom={"2rem"}
      >
        ¿Listo para ser la solución que nuestra audiencia necesita?
      </Box>
      <Box
        component={Typography}
        sx={{ fontWeight: 600 }}
        variant={'h4'}
        gutterBottom
        align={'center'}
        marginBottom={"2rem"}
        color="textSecondary"
      >
        Forma parte de La Dosis Positiva y conecta con una comunidad que valora la practicidad, el crecimiento y el bienestar real. Hagamos que tu marca sea el próximo paso positivo en la vida de nuestros seguidores.
      </Box>

      <Grid container spacing={4}>
        <Grid item container alignItems={'center'} xs={12} md={6}>
          <Box data-aos={isMd ? 'fade-right' : 'fade-up'}>
            <Box marginBottom={2}>
              <Typography
                variant="h5"
                color="textPrimary"
                sx={{
                  fontWeight: 700,
                }}
              >
                UGC, segmentos de bienestar y networking interactivo: tu marca como aliado real de nuestra comunidad.
              </Typography>
            </Box>
            <Box marginBottom={3}>
              <Typography
                variant="body1"
                component="p"
                color="textSecondary"
                sx={{ fontWeight: 400 }}
              >
                La Dosis Positiva, con Yanira Bocaranda al frente. Contenido que transforma.
              </Typography>
            </Box>
            <Box
              display="flex"
              flexDirection={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'stretched', sm: 'flex-start' }}
            >
              <Button
                component={'a'}
                variant="contained"
                color="primary"
                size="large"
                fullWidth={isMd ? false : true}
                onClick={handleOpenWhatsApp}
                target={'_blank'}
              >
                Patrocinar La Dosis Positiva
              </Button>
              <Box
                marginTop={{ xs: 2, sm: 0 }}
                marginLeft={{ sm: 2 }}
                width={{ xs: '100%', md: 'auto' }}
              >
                <Button
                  component={'a'}
                  href={'https://www.tnonetwork.com'}
                  variant="outlined"
                  color="primary"
                  size="large"
                  fullWidth={isMd ? false : true}
                >
                  TNO Network
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            height={'100%'}
            width={'100%'}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            <Box height={'100%'} width={'100%'} maxHeight={600}>
              <Box
                component="img"
                src="/images/yanirabellatno.jpeg"
                alt="Yanira Bocaranda - La Dosis Positiva, TNO"
                sx={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: 600,
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | La Dosis Positiva: Contenido que Transforma.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
